import { Component, Input, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-customer-sales-by-trend-chart',
  templateUrl: './customer-sales-by-trend-chart.component.html',
  styleUrls: ['./customer-sales-by-trend-chart.component.scss'],
})
export class CustomerSalesByTrendChartComponent implements OnInit {
  @Input() salesByTrend: any = {};
  @Input() legend: string = '';

  constructor() { }
  option: EChartsOption = {};

  ngOnInit(): void {

    this.getChart();
  }

  getChart() {
    const data = this.salesByTrend;
    const ytdValues = [
      data.ytd2022,
      data.ytd2023,
      data.ytd2024,
      data.ytd2025,
      data.ytd2026,
    ];

    const fyValues = [
      data.fy2022,
      data.fy2023,
      data.fy2024,
      data.fy2025,
      data.fy2026,
    ];

    const years = ['2022', '2023', '2024', '2025', '2026'];

    this.option = {
      title: {
        left: 'center',
        textStyle: {
          color: '#000000',
          fontSize: '14px',
        },
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'none'
        },
        formatter: function (params) {
          return params.map(param => {
            //const value = (param.value instanceof Array ? param.value[1] : param.value) / 10;
            const value = (param.value instanceof Array ? param.value[1] : param.value);
            //  return `${param.seriesName}: ${value.toFixed(1)}`;
            return `${param.seriesName}: ${Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
          }).join('<br/>');
        }
        
      },
      legend: {
        data: ['FY', 'YTD'],
        top: 'bottom',
        selectedMode: false, 
      },
      xAxis: {
        type: 'category',
        data: years,
        axisLabel: {
          align: 'center',
          fontSize: 12,
        },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          show: false
        },
        splitLine: {
          show: false, 
        }
      },
      series: [
       
        {
          name: 'FY',
          type: 'bar',
          stack: 'total',
          data: fyValues,
          label: {
            show: true,
            color: 'black',
            position: 'top',
            formatter: function (value: any) {
              return (value.value / 1000000).toFixed(1) + 'M';
            }
          },
          itemStyle: {
            color: '#D3D3D3'
          }
          
        },
         {
          name: 'YTD',
          type: 'scatter',
          data: ytdValues.map((value, index) => {
            return [years[index], value]; 
          }),
          symbolSize: 10, 
          itemStyle: {
            color: 'red', 
          },
          label: {
            position: 'bottom',
            show: true, 
            color: 'black',
            formatter: function (params) {
              return (params?.value?.[1] / 1000000).toFixed(1) + 'M';
            }
          }
        }
      ]
    };
  }

  reset() {
    this.getChart();
  }
}
